document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto projektu (detail-2)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-project-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
            initialSlide: 0,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2,
                    initialSlide: 1
                },
            }
        });
    }());
});